import { postJsonForBlob, type PostJsonForBlobOptions } from "@/apis/config/http";

/** Cuerpo de POST /api/v1/installation/package (microservicio de ZIP). */
export interface InstallationPackageRequestBody {
  institutionUid: string;
  modules: string[];
  caddyDomain: string;
  institutionName: string;
  prefixDicom?: string;
  /**
   * Si el backend valida enlaces públicos sin sesión admin, enviar el id del documento
   * Firestore `install_links/{id}` junto con el resto de campos del enlace.
   */
  installLinkId?: string;
  /** Referencia a una API Key (existente o recién creada). */
  apiKeyId?: string;
}

const PACKAGE_ENDPOINT = "/api/v1/installation/package";
const PACKAGE_REQUEST_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutos

/**
 * Solicita el ZIP al API y devuelve el blob + nombre sugerido (Content-Disposition).
 */
export async function requestInstallationPackage(
  body: InstallationPackageRequestBody,
  options?: PostJsonForBlobOptions
): Promise<{ blob: Blob; filename?: string }> {
  const modules = [...new Set(body.modules.map((m) => m.trim()).filter(Boolean))];
  if (modules.length === 0) {
    throw new Error("Selecciona al menos un módulo");
  }
  const payload: InstallationPackageRequestBody = {
    institutionUid: body.institutionUid.trim(),
    modules,
    caddyDomain: body.caddyDomain.trim(),
    institutionName: body.institutionName.trim(),
    ...(body.prefixDicom?.trim() ? { prefixDicom: body.prefixDicom.trim() } : {}),
    ...(body.installLinkId?.trim() ? { installLinkId: body.installLinkId.trim() } : {}),
    ...(body.apiKeyId?.trim() ? { apiKeyId: body.apiKeyId.trim() } : {}),
  };
  return postJsonForBlob(PACKAGE_ENDPOINT, payload, {
    timeoutMs: PACKAGE_REQUEST_TIMEOUT_MS,
    ...(options ?? {}),
  });
}
